module.exports = __webpack_public_path__ + "static/media/main-bg@2x.b31c53f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_230/imgs/main-bg@2x.png
// module id = 1755
// module chunks = 0